import { Link } from "react-router-dom";
import { categories } from "@/mocks/news";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 font-label text-lg font-extrabold text-background-50">
                51
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-background-50">
                爆料网
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              51爆料网专注于提供最新、最真实的社会爆料和热点新闻，覆盖多领域多角度，帮助用户及时了解各类突发事件和深度报道。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-video-line", label: "短视频" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-900 text-primary-100 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 flex items-center gap-2 font-heading text-sm font-semibold text-background-50">
              <a href="#footer-nav" className="hover:text-accent-400">
                快速导航
              </a>
            </h4>
            <ul id="footer-nav" className="space-y-3 text-sm text-primary-200">
              {[
                { label: "首页", to: "/" },
                { label: "全部爆料", to: "/category/all" },
                { label: "关于我们", to: "/about" },
                { label: "联系我们", to: "/contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="transition-colors hover:text-accent-400">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 flex items-center gap-2 font-heading text-sm font-semibold text-background-50">
              <a href="#footer-cats" className="hover:text-accent-400">
                爆料分类
              </a>
            </h4>
            <ul id="footer-cats" className="grid grid-cols-2 gap-3 text-sm text-primary-200">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.id}`} className="transition-colors hover:text-accent-400">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 flex items-center gap-2 font-heading text-sm font-semibold text-background-50">
              <a href="#footer-notice" className="hover:text-accent-400">
                免责声明
              </a>
            </h4>
            <ul id="footer-notice" className="space-y-3 text-sm leading-relaxed text-primary-200">
              <li>本站内容仅为信息展示与阅读参考，演示数据不代表真实事件。</li>
              <li>如涉及版权或内容异议，欢迎通过联系我们页提交反馈。</li>
              <li>转载本站原创内容请注明来源。</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 51爆料网 · 权威实时爆料新闻与热点资讯平台</p>
          <p className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <span>本站为演示站点，内容与数据仅供展示</span>
            <span className="hidden sm:inline">·</span>
            <span className="whitespace-nowrap">备案号：京ICP备00000000号</span>
          </p>
        </div>
      </div>
    </footer>
  );
}